<template>
  <div>
    <a-modal
      v-model="visible"
      :title="$t('pubGicSet.DeAllocation')"
      width="90%"
      :maskClosable="maskClosable"
    >
      <template slot="footer">
        <a-button type="primary" size="small" @click="handleOk">{{ $t('pubGicSet.DeAllocation') }}</a-button>
      </template>
      <vxe-table
        stripe
        border
        highlight-hover-row
        resizable
        size="mini"
        :data.sync="tableData"
        ref="deallccationRefs">
        <template v-slot:empty>
          <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
        </template>
        <vxe-table-column type="checkbox" width="60"></vxe-table-column>
        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="relId" :title="$t('pubGicSet.RelID')"></vxe-table-column>
        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="batchNo" :title="$t('pubGicSet.BatchNo')"></vxe-table-column>
        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="sku" :title="$t('pubGicSet.SKU')"></vxe-table-column>
        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="batchNo" :title="$t('pubGicSet.Location')"></vxe-table-column>
        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="allocatedQty" :title="$t('pubGicSet.Qty')"></vxe-table-column>
        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="locationCode" :title="$t('pubGicSet.LotID')"></vxe-table-column>
        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="originalLotId" :title="$t('pubGicSet.originalLotId')"></vxe-table-column>
        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="soLineSeq" :title="$t('pubGicSet.soLineSeq')"></vxe-table-column>
        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="pickLineSeq" :title="$t('pubGicSet.PickLineSeq')"></vxe-table-column>
        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="creator" :title="$t('generic.Creator')"></vxe-table-column>
        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="createTime" :title="$t('generic.CreateTime')"></vxe-table-column>
        <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="modifyTime" :title="$t('pubGicSet.ModifyTime')"></vxe-table-column>
      </vxe-table>
    </a-modal>
  </div>
</template>
<script>
import ajax from "../../../api/ajax";
import api from "../../../api/url";
export default {
  data() {
    return {
      visible: false,
      maskClosable: false,
      tableData: []
    };
  },
  methods: {
    openModal(params) {
      ajax.post(api.SOFINDALLOCATION, { uids: params }).then(res => {
        if (res.code == 200) {
          this.tableData = res.data;
        }
      });
      this.visible = true;
    },
    handleOk() {
      let mapsArr = this.$refs.deallccationRefs.getCheckboxRecords();
      let params = [];
      if (mapsArr.length > 0) {
        for (let ii in mapsArr) {
          params.push(mapsArr[ii].uid);
        }
      }
      ajax.post(api.SODETAILALLLOCATION, { uids: params }).then(res => {
        if (res.code == 200) {
          this.$refs.deallccationRefs.clearSelection();
          this.visible = false;
        } else {
          this.$customMessage.error(res.msg);
        }
      });
    }
  }
};
</script>
